// extracted by mini-css-extract-plugin
export default {"tagsButtonGroup":"TagList_tagsButtonGroup__tLoUX","toggleButton":"TagList_toggleButton__a2g6A","active":"TagList_active__qXJEq"};